export default {
  "enterAValidAppNameLowercaseLettersAndDigitsOnly": "Enter a valid app name (lowercase letters and digits only)",
  "enterAValidSystemdUnitName": "Enter a valid systemd unit name",
  "couldNotRegisterApp": "Could not register app",
  "addCustomApp": "Add custom app",
  "closeDialog": "Close dialog",
  "appName": "App name",
  "eGMyapp": "e.g. myapp",
  "lowercaseLettersAndDigitsOnlyAShortIdentifierNoSpaces": "Lowercase letters and digits only — a short identifier, no spaces or symbols.",
  "launchType": "Launch type",
  "systemdService": "systemd service",
  "cronManual": "cron / manual",
  "systemdUnit": "systemd unit",
  "aManualAppGetsACopyReadyLaunchRecipeInstead": "A manual app gets a copy-ready launch recipe instead of an automatic drop-in. After registering, open its row and choose \"Show recipe\".",
  "cancel": "Cancel",
  "registerApp": "Register app",
  "olderThan7Days": "Older than 7 days",
  "olderThan30Days": "Older than 30 days",
  "olderThan90Days": "Older than 90 days",
  "allLoggedDeletes": "All logged deletes",
  "clearLoggedDeletes": "Clear logged deletes",
  "clearLog": "Clear log",
  "couldNotClearTheLog": "Could not clear the log",
  "clearDeleteLog": "Clear delete log",
  "clearsLoggedActivityOnlyTheAllTimeSafelyHandledTotal": "Clears logged activity only. The all-time safely-handled total is not changed.",
  "anySize": "Any size",
  "anyTime": "Any time",
  "last24Hours": "Last 24 hours",
  "last7Days": "Last 7 days",
  "last30Days": "Last 30 days",
  "fullPath": "Full path",
  "size": "Size",
  "process": "Process",
  "when": "When",
  "app": "App",
  "customApp": "custom app",
  "notMappedToAProtectedApp": "not mapped to a protected app",
  "effectiveThreshold": "Effective threshold",
  "appOverride": "app override",
  "serverDefault": "server default",
  "deleteSelectedLogEntries": "Delete selected log entries",
  "delete": "Delete",
  "couldNotDeleteEntries": "Could not delete entries",
  "deleteLogEntry": "Delete log entry",
  "removeThisEntryFromTheDeleteLogThisClearsLogged": "Remove this entry from the delete log? This clears logged activity only — the all-time total is unaffected.",
  "deletedLogEntry": "Deleted log entry",
  "couldNotDeleteEntry": "Could not delete entry",
  "all": "All",
  "time": "Time",
  "appActor": "App / actor",
  "file": "File",
  "recentProtectedDeletes": "Recent protected deletes",
  "largeDeletesThatWerePacedToKeepTheServerResponsive": "Large deletes that were paced to keep the server responsive. Expand a row for the full path, size, and the process behind it.",
  "refresh": "Refresh",
  "retry": "Retry",
  "searchByAppProcessOrPath": "Search by app, process, or path...",
  "noProtectedDeletesRecordedYet": "No protected deletes recorded yet.",
  "deleteThisLogEntry": "Delete this log entry",
  "loadingRecipe": "Loading recipe…",
  "pasteThisBeforeTheAppSLaunchCommandInIts": "Paste this before the app's launch command in its crontab or startup script. It takes effect on the next run — no restart needed.",
  "copy": "Copy",
  "copyRecipeToClipboard": "Copy recipe to clipboard",
  "recipeCopiedToClipboard": "Recipe copied to clipboard",
  "thisAppIsProtectedAutomaticallyItsSystemdDropInIs": "This app is protected automatically — its systemd drop-in is managed for you, so there is no manual step to run.",
  "deleteProtectionDocumentation": "Delete protection documentation",
  "notFound": "Not found",
  "failedToLoadDeleteProtectionStatus": "Failed to load delete protection status",
  "requestFailed": "Request failed",
  "actionFailed": "Action failed",
  "pleaseTryAgain": "Please try again.",
  "serverWideDeleteProtectionEnabled": "Server-wide delete protection enabled",
  "serverWideDeleteProtectionDisabled": "Server-wide delete protection disabled",
  "deleteProtection": "Delete Protection",
  "preventsTheWholeServerFreezeThatDeletingVeryLargeFiles": "Prevents the whole-server freeze that deleting very large files can trigger on media and download apps, by pacing those deletes so the box stays responsive.",
  "loadingProtectionStatus": "Loading protection status…",
  "couldNotLoadStatus": "Could not load status",
  "protectionIsNotSetUpYet": "Protection is not set up yet",
  "theDeleteProtectionSafeguardHasNotBeenBuiltOnThis": "The delete-protection safeguard has not been built on this server. It activates the first time a supported media or download app is installed.",
  "unregisterCustomApp": "Unregister custom app",
  "unregister": "Unregister",
  "largeDeletesSafelyHandled": "Large deletes safely handled",
  "sinceProtectionWasFirstEnabledOnThisServer": "Since protection was first enabled on this server.",
  "serverWideProtection": "Server-wide protection",
  "theMasterSwitchIsOffNoAppIsProtectedWhatever": "The master switch is off — no app is protected, whatever its own toggle shows.",
  "masterSwitchOnProtectionAppliesAcrossEverySupportedAppBelow": "Master switch on — protection applies across every supported app below.",
  "off": "Off",
  "on": "On",
  "toggleServerWideDeleteProtection": "Toggle server-wide delete protection",
  "serverDefaultThreshold": "Server default threshold",
  "deletesOfFilesAtOrAboveThisSizeArePaced": "Deletes of files at or above this size are paced; smaller deletes run normally. Every app inherits this floor unless you give it its own threshold in the table below.",
  "deleteProtectionSizeThreshold": "Delete protection size threshold",
  "protectedApps": "Protected apps",
  "toggleAnAppToOptItInOrOutAnd": "Toggle an app to opt it in or out, and set its own delete threshold or leave it on the server default.",
  "noSupportedAppsAreInstalledYetProtectionAppliesAutomaticallyOnce": "No supported apps are installed yet. Protection applies automatically once a media or download app is installed.",
  "status": "Status",
  "threshold": "Threshold",
  "protection": "Protection",
  "perAppTogglesAreUnavailableWhileServerWideProtectionIs": "Per-app toggles are unavailable while server-wide protection is off.",
  "thisAppHasItsOwnThresholdAndNoLongerFollows": "This app has its own threshold and no longer follows the server default.",
  "custom": "Custom",
  "turnOnServerWideProtectionFirstToManageThisApp": "Turn on server-wide protection first to manage this app individually.",
  "adminRegisteredCustomApp": "Admin-registered custom app",
  "manualCronLaunch": "Manual — cron/launch",
  "notInstalled": "Not installed",
  "protected": "Protected",
  "notProtected": "Not protected",
  "showRecipe": "Show recipe",
  "registered": "{{app}} registered for delete protection",
  "unitHelp": "The unit BASE name — {{name}} covers both {{instance}} and {{service}}.",
  "registering": "Registering…",
  "purgeAllConfirm": "This clears {{scope}} from this list. It only clears LOGGED ACTIVITY — the \"large deletes safely handled\" total is unaffected. This cannot be undone.",
  "purgeOlderConfirm": "This clears {{scope}} from this list. It only clears LOGGED ACTIVITY — the \"large deletes safely handled\" total is unaffected. This cannot be undone.",
  "allDeleteLog": "the entire delete log",
  "olderDeleteLog": "log entries older than {{count}} days",
  "cleared_one": "Cleared {{count}} logged delete",
  "cleared_other": "Cleared {{count}} logged deletes",
  "exactBytes_one": "{{count}} byte",
  "exactBytes_other": "{{count}} bytes",
  "entries_one": "{{count}} entry",
  "entries_other": "{{count}} entries",
  "bulkDeleteConfirm": "Remove {{entries}} from the delete log? This clears logged activity only — the all-time total is unaffected.",
  "deletedEntries_one": "Deleted {{count}} log entry",
  "deletedEntries_other": "Deleted {{count}} log entries",
  "recentOfTotal": "Showing the most recent {{count}} of {{total}}.",
  "deleteSelected": "Delete selected ({{count}})",
  "recipeFor": "Recipe — {{app}}",
  "copied": "Copied!",
  "appliesAtOrAbove": "Applies to deletes at or above {{size}}.",
  "deleteUnit_one": "delete",
  "deleteUnit_other": "deletes",
  "protectionEnabled": "Protection enabled for {{app}}",
  "protectionDisabled": "Protection disabled for {{app}}",
  "serverThresholdSet": "Server default threshold set to {{size}}",
  "appThresholdSet": "{{app}} threshold set to {{size}}",
  "appInherits": "{{app}} now inherits the server default",
  "appRemoved": "{{app}} removed from delete protection",
  "notProtectedDefault": "Not protected right now. Enabling it applies the server default ({{size}}).",
  "notInstalledSwitch": "{{app}} is not installed — there is nothing to protect yet.",
  "thresholdFor": "Delete threshold for {{app}}",
  "switchOffWarning": "Turning this off re-exposes {{app}} to whole-server freezes on large deletes.",
  "switchOnHelp": "Turn on to pace large deletes for {{app}} and keep the server responsive.",
  "toggleFor": "Toggle delete protection for {{app}}",
  "unregisterFor": "Unregister {{app}}",
  "unregisterConfirm": "Remove {{app}} from delete protection? Its protection drop-in (if any) is removed. You can register it again later.",
  "currentThreshold": "Currently {{size}} - the floor each app inherits unless overridden below",
  "builtInThreshold": " · built-in {{size}}",
  "thresholdRange": "Range {{min}} – {{max}}.",
  "serverDefaultSize": "Server default ({{size}})",
  "never": "Never",
  "appNotInstalled": "{{app}} is not installed, so there is nothing to protect yet.",
  "backendFailedToReadDeleteProtectionStatus": "Failed to read delete-protection status",
  "backendDeleteProtectionStatusReturnedMalformedOutput": "Delete-protection status returned malformed output",
  "backendDeleteProtectionStatusDidNotMatchTheExpectedContract": "Delete-protection status did not match the expected contract",
  "backendFailedToEnableDeleteProtection": "Failed to enable delete protection",
  "backendFailedToDisableDeleteProtection": "Failed to disable delete protection",
  "backendFailedToReconcileDeleteProtection": "Failed to reconcile delete protection",
  "backendFailedToSetDeleteProtectionThreshold": "Failed to set delete-protection threshold",
  "backendFailedToResetDeleteProtectionThreshold": "Failed to reset delete-protection threshold",
  "backendFailedToRegisterTheCustomApp": "Failed to register the custom app",
  "backendFailedToUnregisterTheCustomApp": "Failed to unregister the custom app",
  "backendFailedToReadTheAppRecipe": "Failed to read the app recipe",
  "backendDeleteProtectionRecipeDidNotMatchTheExpectedContract": "Delete-protection recipe did not match the expected contract",
  "backendFailedToReadTheProtectedDeleteLog": "Failed to read the protected-delete log",
  "backendDeleteProtectionLogDidNotMatchTheExpectedContract": "Delete-protection log did not match the expected contract",
  "backendFailedToPruneTheProtectedDeleteLog": "Failed to prune the protected-delete log",
  "backendDeleteProtectionPruneDidNotMatchTheExpectedContract": "Delete-protection prune did not match the expected contract",
  "backendUnauthorized": "Unauthorized",
  "backendAdminPrivilegesRequired": "Admin privileges required",
  "backendDeleteProtectionManagementIsNotEnabledForYourAccount": "Delete protection management is not enabled for your account",
  "backendInvalidCSRFToken": "Invalid CSRF token",
  "backendInvalidApp": "Invalid app",
  "backendResetRequiresAnApp": "reset requires an app",
  "backendAThresholdInBytesIsRequired": "A threshold in bytes is required",
  "backendInvalidLimit": "Invalid limit",
  "backendDeleteProtectionIsNotEnabled": "Delete protection is not enabled",
  "backendDeleteProtectionRecipeReturnedMalformedOutput": "Delete-protection recipe returned malformed output",
  "backendDeleteProtectionListLogReturnedMalformedOutput": "Delete-protection list-log returned malformed output",
  "backendDeleteProtectionPruneLogReturnedMalformedOutput": "Delete-protection prune-log returned malformed output",
  "backendResetAndBytesAreMutuallyExclusive": "reset and bytes are mutually exclusive",
  "backendASystemdRegistrationRequiresAUnit": "A systemd registration requires a unit",
  "backendAManualRegistrationTakesNoUnit": "A manual registration takes no unit",
  "backendExactlyOneOfOlderThanDaysBeforeIdsOrAllIsRequired": "Exactly one of olderThanDays, before, ids, or all is required",
  "backendWholeBytes": "Threshold must be a whole number of bytes",
  "backendBelowFloor": "Threshold below the 16 MiB floor",
  "backendAboveCeiling": "Threshold above the 1 TiB ceiling",
  "backendInvalidAppShortName": "Invalid app short-name",
  "backendInvalidSystemdUnitName": "Invalid systemd unit name",
  "backendInvalidLogRowId": "Invalid log-row id",
  "backendRequired": "A value is required",
  "backendExpectedString": "A text value is required",
  "backendExpectedNumber": "A number is required",
  "backendExpectedInteger": "A whole number is required",
  "backendExpectedObject": "An object is required",
  "backendExpectedArray": "A list is required",
  "backendExpectedBoolean": "A boolean value is required",
  "backendStringMin": "Enter at least {{bound}} characters",
  "backendStringMax": "Enter no more than {{bound}} characters",
  "backendArrayMin": "Select at least {{bound}} items",
  "backendArrayMax": "Select no more than {{bound}} items",
  "backendPositive": "The value must be greater than zero",
  "backendUnknownFields": "Unrecognized fields: {{fields}}",
  "backendKindChoice": "Choose systemd or manual",
  "backendTrueRequired": "The value must be true",
  "backendInvalidThreshold": "Invalid threshold",
  "backendInvalidRegistration": "Invalid registration",
  "backendInvalidPruneRequest": "Invalid prune request"
} as const;
